// Chrome 38 Symbol has incorrect toString conversion
module.exports = !require('../internals/fails')(function () {
  // eslint-disable-next-line no-undef
  String(Symbol());
});



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/native-symbol.js
// module id = 172
// module chunks = 0